var exports = {
  "_H": "SummaryContainer__sniOan",
  "qj": "SummaryHeader__GqwhCL",
  "nk": "SummaryTitle__Hh10NA",
};

module.exports = exports;
